exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.enfasy[data-v-641551b8] {\n    background-color: #cacaca;\n}\n", ""]);

// exports
